module.exports = __webpack_public_path__ + "static/media/Portrait-10078.ee8c97b2.jpg";